import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../ui/button/button";
import { HERO_TEXT, METRICS } from "../../../lib/landingContent";
import "./hero.css";
import MagneticGrid from "../magnetic grid/magneticgrid";
const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section" id="hero">
      <MagneticGrid />
      <div className="hero-inner">
       <h1 className="hero-title">
  <span className="hero-title-line">Your brand</span>

  <span className="hero-title-accent">
engineered by HxAI.</span>

</h1>

        <p className="hero-description">{HERO_TEXT.description}</p>

        <div className="hero-actions">
          <Button
            size="sm"
            className="btn-hero-primary"
            onClick={() => navigate("/audit?type=web")}
          >
            {HERO_TEXT.ctaPrimary}
          </Button>
          <Button
            variant="outline"
            size="md"
            className="btn-hero-outline"
            onClick={() => navigate("/audit?type=social")}
          >
            {HERO_TEXT.ctaSecondary}
          </Button>
        </div>

        <div className="hero-metrics">
          {METRICS.map((metric) => (
            <div className="hero-metric" key={metric.label}>
              <p className="hero-metric-label">{metric.label}</p>
              <p className="hero-metric-value">{metric.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
